import Header from 'modules/header/components/header'
import { PureComponent, Suspense } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import withStorageContextProvider from 'react-storage-context'
import entryPoint from 'shared/components/entry-point-hoc'
import GTALogger from 'shared/components/gta-logger'
import ModalMessage from 'shared/components/message/modal-message'
import ReportOnSPA from 'shared/components/router/report-on-spa'
import ContextManagers from 'shared/context-managers'
import { primaryCTA } from 'shared/css/colors.css'
import channelSelectorItems from 'shared/redux/channel-selector'
import creationFilters from 'shared/redux/creation-filters'
import creationTool from 'shared/redux/creation-tool'
import draw from 'shared/redux/draw'
import { getDefaultStore } from 'shared/redux/init-store'
import { setUserPermissions } from 'shared/redux/permissions'
import { setUser } from 'shared/redux/user'
import DesktopGlobalCSS from '../../css/global-css'
import error from '../redux/error'
import slideshow from '../redux/slideshow'
import GifMakerRoute from './route'

const store = getDefaultStore({ creationTool, channelSelectorItems, slideshow, error, draw, creationFilters })
export const PromptIds = {
    LOOSE_YOUR_WORK: 'LOOSE_YOUR_WORK',
    NOT_ANIMATED: 'NOT_ANIMATED',
    CANCEL_UPLOAD: 'CANCEL_UPLOAD',
}
export const PromptMessages = {
    [PromptIds.NOT_ANIMATED]: {
        title: `Your artwork must have an animation`,
        cancelLabel: `Got it`,
        description: 'Please add a filter with an animation, or decorate with other options',
        onConfirm: null,
        cancelColor: primaryCTA,
    },
    [PromptIds.LOOSE_YOUR_WORK]: {
        title: `Are you sure you want to start over?`,
        confirmLabel: `Yes, start over`,
    },
    [PromptIds.CANCEL_UPLOAD]: {
        title: `Are you sure you want to cancel your upload?`,
        confirmLabel: `Yes, cancel`,
        description: `You can upload again after you're done editing`,
    },
}

@entryPoint(store)
@withStorageContextProvider('giphy-desktop')
export default class App extends PureComponent {
    static defaultProps = {}
    state = {
        isPrompt: false,
    }
    componentWillMount() {
        const { permissions, user } = this.props
        user && store.dispatch(setUser({ loggedIn: true, username: user.username, isStaff: user.is_staff }))
        store.dispatch(setUserPermissions(permissions))
    }
    render() {
        const { showSearch, showBrowse, searchTerm, user } = this.props
        const headerProps = { showSearch, showBrowse, searchTerm, user }
        const { isPrompt } = this.state
        return (
            <>
                <DesktopGlobalCSS />
                <Provider store={store}>
                    <BrowserRouter
                        getUserConfirmation={(message, navigate) => {
                            this.navigate = navigate
                            this.promptId = message
                            this.setState({ isPrompt: true })
                        }}
                    >
                        <Suspense fallback={null}>
                            <ContextManagers channel_access={user?.channel_access}>
                                <ReportOnSPA />
                                <Header {...headerProps} />
                                <GTALogger />
                                <GifMakerRoute {...this.props} />
                                {isPrompt && (
                                    <ModalMessage
                                        onConfirm={() => {
                                            this.setState({ isPrompt: false })
                                            this.navigate(true)
                                        }}
                                        onCancel={() => {
                                            this.setState({ isPrompt: false })
                                            this.navigate(false)
                                        }}
                                        {...PromptMessages[this.promptId]}
                                    />
                                )}
                            </ContextManagers>
                        </Suspense>
                    </BrowserRouter>
                </Provider>
            </>
        )
    }
}
